import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { UserService } from '../shared/user.service';
import { TransferDataService } from '../transfer-data.service';
import { BaseDataService } from '../service/base-data.service';
import { BaseData, BaseDataEmployee, BaseDataFundInstitution, BaseDataPayment, BaseDataSaveResult } from '../model/base-data.model';
import { parse } from 'querystring';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

@Component({
  selector: 'compare-base-details',
  templateUrl: './compare-base-details.component.html',
  styleUrls: ['./compare-base-details.component.css'],
  providers: [ConfirmationService]
})
export class CompareBaseDetailsComponent implements OnInit { 
  msg: string = '';
  msgs: any[] = [];
  userDetails: any;
  listcustomer: any[] = [];
  selectedCustomerId: any = null;
  baseData: BaseData = null;
  selectedEmployeeIdentityNumber: any = null;
  viewAddNewFund: boolean = false;
  currentEmployeeToAddNewFund: BaseDataEmployee = null;
  selectedFundInstitutionId: string = null;
  newIdentityNumber: string = null;
  newFirstName: string = null;
  newLastName: string = null;
  isShowNewEmployee: boolean = false;
  sugHafrashaList: any[];

  showImportByFeedbackDialog: boolean = false;
  importFeedabckMonth: string;
  isImported: boolean = false;
  isDelta: boolean = false;


  constructor(private dataService: TransferDataService, private baseDataService: BaseDataService, private router: Router, private userService: UserService, private confirmationService: ConfirmationService) { }
  ngOnInit() {
    this.userService.getUserClaims().subscribe((result: any) => {
      this.userDetails = result;
      if (this.userDetails && (this.userDetails.ClientRoleSupport || this.userDetails.ClientRoleAdministration || this.userDetails.ClientRoleSemiAdministrator)) {
        this.dataService.getCustomers().subscribe((result: any) => {
          this.listcustomer = result;
          this.listcustomer.unshift({ label: 'בחר מעסיק', value: null });
          
          // TODO: DEBUG:::
          // this.selectedCustomerId = '515050581';
          // this.funOnChange();

        },
          (err: HttpErrorResponse) => {
            this.showMessage('error', '', 'תקלה בקבלת רשימת מעסיקים');
          });
      }
      else {
        this.selectedCustomerId = this.userDetails.CurrentCustomerIdentityNumber;
        this.getBaseData();
      }
    },
      (err: HttpErrorResponse) => {
        this.userDetails = null;
    });


    this.baseDataService.getSugHafrasha().subscribe((result: any) => {
      this.sugHafrashaList = result;
    }, (err: HttpErrorResponse) => {
      this.showMessage('error', '', 'תקלה בקבלת נתוני בוגי הפרשה');
    });

  }

  funOnChange() {
    this.baseData = null;
    this.selectedEmployeeIdentityNumber = null;
    this.getBaseData();
  }

  employeeOnChange() {

  }

  getBaseData() {
    this.isImported = false;
    this.isDelta = false;
    this.baseDataService.getBaseData(this.selectedCustomerId).subscribe((result: any) => {
      this.baseData = result;
    }, (err: HttpErrorResponse) => {
      this.showMessage('error', '', 'תקלה בקבלת נתוני בסיס');
    });
  }

  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summaryMessage, detail: message });   //type='success'/'error'/'warn'/'success'
  }



  deletePayment(employee: BaseDataEmployee, fundInstitution: BaseDataFundInstitution, baseDataPayment: BaseDataPayment) {
    if (baseDataPayment.status == 'new') {
      baseDataPayment.status = 'deleted';
    } else {
      baseDataPayment.status = 'deleted';
    }
  }

  editPayment(employee: BaseDataEmployee, fundInstitution: BaseDataFundInstitution, baseDataPayment: BaseDataPayment) {
    if (baseDataPayment.status == 'new') {
      //
    } else {
      baseDataPayment.status = 'edited';
    }
  }

  deleteFund(employee: BaseDataEmployee, fundInstitution: BaseDataFundInstitution) {
    if (fundInstitution.status == 'new') {
      fundInstitution.status = 'deleted';
    } else {
      fundInstitution.status = 'deleted';
    }
    fundInstitution.BaseDataPayments.forEach(p => {
      p.status = 'deleted';
    });
  }

  addPayment(employee: BaseDataEmployee, fundInstitution: BaseDataFundInstitution) {
    let p: BaseDataPayment = {  Id: null, ShiurHafrasha: null, PolicaOrAccount: '', 
                                SaharMeduvah: null, SchumHafrasha: null, SugTakbul: null, SugHafrasha: null, 
                                UpdateUserId: null, UserName: null, UpdateDate: null, status: 'new' };
    //fundInstitution.BaseDataPayments.push(p);
    fundInstitution.BaseDataPayments.unshift(p);
  }

  addFund(employee: BaseDataEmployee) {
    this.isShowNewEmployee = false;
    this.currentEmployeeToAddNewFund = employee;
    this.viewAddNewFund = true;
    this.selectedFundInstitutionId = null;
  }

  cancelAddNewFund() {
    this.currentEmployeeToAddNewFund = null;
    this.viewAddNewFund = false;
    this.selectedFundInstitutionId = null;

  }

  addNewFund() {
    if (this.isShowNewEmployee) {
        // הוספת עובד חדש יחד עם קופה חדשה
        if (!this.selectedFundInstitutionId) {
          this.showMessage('error', '', 'חובה לבחור קופה להוספה');
          return;
        }
        let fund = this.baseData.AllFundInstitutions.find(f=>f.FundInstitutionId == parseInt(this.selectedFundInstitutionId));
        if (!fund) {
          this.showMessage('error', '', 'חובה לבחור קופה להוספה');
          return;
        }

        let f: BaseDataFundInstitution = {  FundInstitutionId: fund.FundInstitutionId, Name: fund.Name, 
          InstitutionName: fund.InstitutionName, IncomeTaxAuthorizationNumber: fund.IncomeTaxAuthorizationNumber,
          FundInstitutionIdentityNumber: fund.IdentityNumber, Type: fund.Type, 
          BaseDataPayments: [], status: 'new' };

        let e: BaseDataEmployee = {IdentityNumber: this.newIdentityNumber, FirstName: this.newFirstName, LastName: this.newLastName, 
                          FundInstitutions: [f], label: this.newIdentityNumber + ' ' + this.newFirstName + ' ' + this.newLastName , value: this.newIdentityNumber,
                          status: 'new'};
        this.baseData.Employees.unshift(e);

    } else {
        // הוספת קופה חדשה לעובד קיים
        if (!this.selectedFundInstitutionId) {
          this.showMessage('error', '', 'חובה לבחור קופה להוספה');
          return;
        }
        let fund = this.baseData.AllFundInstitutions.find(f=>f.FundInstitutionId == parseInt(this.selectedFundInstitutionId));
        if (!fund) {
          this.showMessage('error', '', 'חובה לבחור קופה להוספה');
          return;
        }
        if (!this.currentEmployeeToAddNewFund) {
          this.showMessage('error', '', 'נא להוסיף קופה חדשה לעובד קיים');
        }
        let f: BaseDataFundInstitution = {  FundInstitutionId: fund.FundInstitutionId, Name: fund.Name, 
                                            InstitutionName: fund.InstitutionName, IncomeTaxAuthorizationNumber: fund.IncomeTaxAuthorizationNumber,
                                            FundInstitutionIdentityNumber: fund.IdentityNumber, Type: fund.Type, 
                                            BaseDataPayments: [], status: 'new' };

        //this.currentEmployeeToAddNewFund.FundInstitutions.push(f);
        this.currentEmployeeToAddNewFund.FundInstitutions.unshift(f);
    }

    this.currentEmployeeToAddNewFund = null;
    this.viewAddNewFund = false;
    this.selectedFundInstitutionId = null;
  }

  addNewEmployee() {
    this.isShowNewEmployee = true;
    this.currentEmployeeToAddNewFund = null;
    this.viewAddNewFund = true;
    this.selectedFundInstitutionId = null;
    this.newIdentityNumber = null;
    this.newFirstName = null;
    this.newLastName = null;

    // let fund = this.baseData.AllFundInstitutions[1];
    // let f: BaseDataFundInstitution = {  FundInstitutionId: fund.FundInstitutionId, Name: fund.Name, 
    //   InstitutionName: fund.InstitutionName, IncomeTaxAuthorizationNumber: fund.IncomeTaxAuthorizationNumber,
    //   FundInstitutionIdentityNumber: fund.IdentityNumber, Type: fund.Type, 
    //   BaseDataPayments: [], status: 'new' };


    // let e: BaseDataEmployee = {IdentityNumber: '123', FirstName: 'aaa', LastName: 'bbb', 
    //                           FundInstitutions: [f], label: '123 aaa bbb' , value: '123',
    //                           status: 'new'};
    // this.baseData.Employees.unshift(e);
  }

  saveBaseData() {
    this.confirmationService.confirm({
      message: 'האם ברצונך לשמור את השינויים בנתוני בסיס?',
      accept: () => {
          this.baseDataService.saveBaseData(this.selectedCustomerId, this.baseData).subscribe((result: any) => {
            let res: BaseDataSaveResult = result;
            if (res.Succeeded) {
              this.showMessage('success', '', 'נתוני בסיס נשמרו');
              this.getBaseData();
            } else {
              this.showMessage('error', '', res.ErrorMessage);
            }
          }, (err: HttpErrorResponse) => {
            this.showMessage('error', '', 'תקלה בשמירת נתוני בסיס');
          });
      }
    }); 
  }

  importBaseDateByFeedbackShowDilaog() {
    this.showImportByFeedbackDialog = true;
  }

  importBaseDateByFeedback(isDelta: boolean) {
    if (!this.importFeedabckMonth || (this.importFeedabckMonth && this.importFeedabckMonth.length!=6)) {
      this.showMessage('error', '', 'נא להזין חודש שכר במבנה yyyymm');
      return;
    }
    this.isDelta = isDelta;

    this.baseDataService.getBaseDataImportByFeedback(this.selectedCustomerId, this.importFeedabckMonth, this.isDelta).subscribe((result: any) => {
      this.baseData = result;
      this.isImported = true;
      this.showImportByFeedbackDialog = false;
    }, (err: HttpErrorResponse) => {
      this.showMessage('error', '', 'תקלה בקבלת נתוני בסיס - ייבוא מהיזון חוזר');
    });

  }

  saveImportedBaseData() {
    this.confirmationService.confirm({
      message: 'האם ברצונך לשמור את השינויים בנתוני בסיס?',
      accept: () => {
          this.baseDataService.saveBaseDataImportByFeedback(this.selectedCustomerId, this.baseData, this.isDelta).subscribe((result: any) => {
            let res: BaseDataSaveResult = result;
            if (res.Succeeded) {
              this.showMessage('success', '', 'נתוני בסיס נשמרו');
              this.getBaseData();
            } else {
              this.showMessage('error', '', res.ErrorMessage);
            }
          }, (err: HttpErrorResponse) => {
            this.showMessage('error', '', 'תקלה בשמירת נתוני בסיס');
          });
      }
    }); 
  }

}


// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/compare-base-details/compare-base-details.component.ts